import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { HelmetProvider } from "react-helmet-async";
import { store } from "services/redux/store";
import { Provider } from "react-redux";

import "assets/css/index.css";
import "assets/css/posts.css";
import "assets/css/communities.css";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <Provider store={store}>
        <HelmetProvider context={{}}>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </HelmetProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
